import utils from 'Utils/object';
import { lengthen } from './queryParser';

const { buildObject, deepMerge } = utils;

/**
 * You might ask yourself, "why aren't you using: https://github.com/sindresorhus/query-string"
 * due to the needs of the project, we need to both do custom encoding,
 * as well as supporting more nesting other than just `key=val&key1=val1`
 * homebrewing this functionality lets us easily patch in suport for say:
 * `key=subKey#subVal~subKey1#subVal1&key2=val2` to be decoded to:
 * { key: { subKey: subVal, subk1: subVal1 }, key2: val2 }
 */

/**
 * Build a query object from a query string
 * @param  {string} str string to build the query from
 * @return {object}     query object
 */
export default function getObjectFromString(str) {
  // Safe remove initial query symbol
  const qs = '?' === str[0] ? str.slice(1) : str.slice();
  return lengthen(qs).split('&')
    .map((curr) => curr.split('='))
    .reduce((acc, [key, val]) => {
      let actualValue = -1 < val.indexOf('~') ?
        val.split('~').map((item) => decodeURIComponent(item)) :
        decodeURIComponent(val);
      if (-1 < key.indexOf('-')) {
        const keys = key.split('-')
          .filter((k) => 0 < k.length)
          .reverse();
        // Do a inplace replace for distribution (hackish.. sorry)
        if (-1 < key.indexOf('distribution') && !Array.isArray(actualValue)) {
          actualValue = [actualValue];
        }
        return deepMerge(acc, buildObject(keys, actualValue));
      }
      if (-1 < key.indexOf('indicators') &&
        !Array.isArray(actualValue)) {
        actualValue = [actualValue];
      }
      return { ...acc, [decodeURIComponent(key)]: actualValue };
    }, {});
}



// WEBPACK FOOTER //
// ./app/utils/query/getObjectFromString.js